/**
 * GENERATED by tools/build-content.py from content/valley.toml -- do not edit.
 * Change the toml and rerun; content/README.md says how.
 *
 * The valley's stages (with the share of the family's target each starts
 * at), its times of day, and the compositions its paintings share. Which
 * FILE each stage shows is in art.generated.ts, from the same toml.
 */

export type Stage = "barren" | "recovering" | "growing" | "thriving" | "plentiful";
export type TimeOfDay = "day" | "night";
export type Light = 'day' | 'night';

export interface StageInfo {
  id: Stage;
  /** Where the stage starts, as a whole percent of the target; null: zero and below. */
  fromPercent: number | null;
  /** The short word on Home. */
  label: string;
  /** The caption, and the painting's alt text. */
  words: string;
  /** Below this, the valley rests: no water, no residents. */
  dormant: boolean;
}

export interface TimeInfo {
  id: TimeOfDay;
  /** Local hours, `from` inclusive, `until` exclusive, wrapping past midnight. */
  from: number;
  until: number;
  /** What the rest of the valley (animals, stars, moon) follows. */
  light: Light;
}

/** The balance at which the valley is full, when a family has not set one. */
export const DEFAULT_TARGET = 10000;

/** Emptiest first. */
export const STAGE_LIST: readonly StageInfo[] = [
  {
    "id": "barren",
    "fromPercent": null,
    "label": "dormant",
    "words": "Dormant: the valley is resting, waiting for something to grow.",
    "dormant": true
  },
  {
    "id": "recovering",
    "fromPercent": 0,
    "label": "recovering",
    "words": "Recovering: green is starting to come back.",
    "dormant": false
  },
  {
    "id": "growing",
    "fromPercent": 34,
    "label": "sprouting",
    "words": "Sprouting: the valley is filling in.",
    "dormant": false
  },
  {
    "id": "thriving",
    "fromPercent": 67,
    "label": "flourishing",
    "words": "Flourishing: nearly everything has come back.",
    "dormant": false
  },
  {
    "id": "plentiful",
    "fromPercent": 100,
    "label": "lush",
    "words": "Lush: the valley is full.",
    "dormant": false
  }
];

/** The stage ids alone, emptiest first. */
export const STAGES = ["barren", "recovering", "growing", "thriving", "plentiful"] as const;

/** First match wins. */
export const TIME_LIST: readonly TimeInfo[] = [
  {
    "id": "day",
    "from": 6,
    "until": 19,
    "light": "day"
  },
  {
    "id": "night",
    "from": 19,
    "until": 6,
    "light": "night"
  }
];

/** The time ids alone, in the order they are checked. */
export const TIMES = ["day", "night"] as const;

/** The size each composition's routes were traced at; only the aspect matters. */
export const COMPOSITIONS = {"landscape": {"reference": [1672, 941]}, "portrait": {"reference": [900, 1600]}, "cottage": {"reference": [1672, 941], "horizon": [[0, 0.66], [1, 0.66]], "perches": [[0.82, 0.19], [0.91, 0.24], [0.78, 0.32]], "stations": {"garden": [0.265, 0.73], "doorstep": [0.27, 0.585], "lawn": [0.57, 0.74], "path": [0.335, 0.84]}}, "cottage-portrait": {"reference": [941, 1672], "horizon": [[0, 0.63], [1, 0.63]], "perches": [[0.76, 0.16], [0.87, 0.22], [0.69, 0.27]], "stations": {"garden": [0.3, 0.54], "doorstep": [0.27, 0.42], "lawn": [0.55, 0.74], "path": [0.24, 0.62]}}} as const;

export type SceneId = "meadow" | "cottage";

export interface SceneInfo {
  id: SceneId;
  /** What a parent sees in Settings. */
  label: string;
  /** The painting the picker shows for it (art.generated.ts encodes it). */
  swatch: string | null;
  /** New layouts select their own geometry for each orientation. */
  composition?: Readonly<Record<string, string>>;
}

/** The backgrounds a family can choose; the first is the default. */
export const SCENES: readonly SceneInfo[] = [
  {
    "id": "meadow",
    "label": "Mountain meadow",
    "swatch": "valley-plentiful-v18"
  },
  {
    "id": "cottage",
    "label": "Cottage garden",
    "swatch": "cottage-plentiful-v2",
    "composition": {
      "landscape": "cottage",
      "portrait": "cottage-portrait"
    }
  }
];

export const DEFAULT_SCENE: SceneId = "meadow";
